<template>
  <div style="min-height: 92vh">
    <div v-show="!showCreator">
      <ModuleHeader>Compras</ModuleHeader>
      <v-row>
        <v-col md="4" cols="12">
          <v-menu
            v-model="menuFechaInicial"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="input_date"
                label="Fecha Inicial"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="input_date"
              @input="menuFechaInicial = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="4" cols="12">
          <v-menu
            v-model="menuFechaInicial2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="input_date_final"
                label="Fecha Final"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="input_date_final"
              @input="menuFechaInicial2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="4" cols="12">
          <v-btn color="success" @click="getDocuments()">Buscar</v-btn>
        </v-col>
      </v-row>
      <uv-data-table
        :config="config"
        :data="Documentos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>

      <v-file-input
        ref="hiddenFileInput"
        v-model="selectedFile"
        :accept="acceptedDocuments"
        :multiple="multipleDocuments"
        truncate-length="15"
        class="d-none"
        dense
        outlined
        @change="onFileSelected"
      />
    </div>
    <!-- <v-btn v-show="false" color="green" dark>
      <v-icon>mdi-file-excel-box</v-icon>
      <download-excel
        ref="btnExcel"
        type="xls"
        name="Compras"
        :data="excelData"
      >
        Exportar a Excel
      </download-excel>
    </v-btn>
    <v-btn v-show="false" color="green" dark>
      <v-icon>mdi-file-excel-box</v-icon>
      <download-excel
        ref="btnExcelItems"
        type="xls"
        name="Compras Items"
        :data="excelDataItems"
      >
        Exportar a Excel
      </download-excel>
    </v-btn> -->
    <!-- * ========== Type Form Compra ========== * -->
    <modal v-model="docRecepTypeModal" title="Crear compra por:">
      <v-card elevation="0">
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-btn
                color="green"
                class="py-5"
                dark
                x-large
                block
                @click="
                  docRecepTypeModal = false;
                  docRecepIsManual = true;
                  showModal = true;
                "
              >
                <v-icon left>mdi-pencil</v-icon>
                <span class="font-weight-bold"> Manual </span>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="indigo"
                class="py-5"
                dark
                x-large
                block
                @click="
                  docRecepTypeModal = false;
                  docRecepIsManual = false;
                  showModal = true;
                "
              >
                <v-icon left>mdi-xml</v-icon>
                <span class="font-weight-bold"> XML </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </modal>
    <!-- * ========== Form Compra ========== * -->
    <modal
      v-model="showModal"
      :showFooter="false"
      :fullscreen="true"
      title="Compra"
    >
      <ComprasForm
        v-if="docRecepIsManual"
        :edit="editMode"
        @toggle="toggleModal"
        @successData="successData"
        :key="`Comptas-Manual-${formIndex}`"
        :presentaciones="presentaciones"
        :presentacionesAll="presentacionesAll"
        :dataEdit="editData"
      />

      <ComprasXml
        v-else
        :edit="editMode"
        @toggle="toggleModal"
        @successData="successData"
        :key="`Comptas-XML-${formIndex}`"
        :presentaciones="presentaciones"
        :presentacionesAll="presentacionesAll"
        :dataEdit="editData"
      />
    </modal>

    <!-- * ========== Export To Excel ========== * -->
    <modal v-model="excelModal" title="Exportar a excel">
      <v-card flat class="pa-4">
        <v-row align="center" justify="center" v-show="!docsEmpty">
          <v-col cols="12" md="6" class="text-center">
            <v-btn color="primary" large @click="processExcelInfo">
              <v-icon left>mdi-truck</v-icon>
              Agrupado por proveedor
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" class="text-center">
            <v-btn color="secondary" large @click="processExcelItems">
              <v-icon left>mdi-cart</v-icon>
              Agrupado por items de la compra
            </v-btn>
          </v-col>
        </v-row>
        <v-card-text v-show="docsEmpty" align="center">
          <h2 class="text-center">Favor de buscar compras primero.</h2>
        </v-card-text>
      </v-card>
    </modal>

    <!-- * ========== Documents Compra ========== * -->
    <modal v-model="showDocuments" title="Documentos">
      <v-card>
        <v-card-title>
          {{ editData.Nombre }} - {{ editData.origenNombre }}
        </v-card-title>
        <v-card-text>
          <v-row
            v-for="(doc, index) in listDocuments"
            :key="`Document-${doc.name}-index-${index}`"
          >
            <v-col
              cols="4"
              :class="getDocumentType(doc).textColor"
              class="d-flex align-center font-weight-bold"
            >
              <span> {{ doc.name }} </span>
            </v-col>
            <v-col cols="2" class="d-flex align-center font-weight-bold">
              <v-icon large :color="getDocumentType(doc).color">
                {{ getDocumentType(doc).icon }}
              </v-icon>
            </v-col>
            <v-col cols="4" class="d-flex justify-space-between align-center">
              <v-btn color="indigo" outlined @click="viewDocument(doc)">
                Abrir
              </v-btn>
              <v-btn color="red" outlined @click="deleteDocument(doc.name)">
                Eliminar
              </v-btn>
            </v-col>
          </v-row>
          <!--           <v-list>
            <v-list-item v-for="(doc, index) in listDocuments" :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ doc.name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn color="primary" @click="abrirDocumento(doc)">
                  Abrir
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list> -->
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ComprasForm from "./ComprasForm.vue";
import ComprasXml from "./ComprasXml.vue";
import AcuseCompras from "../../../clases/PdfMakers/AcuseCompra.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ComprasExcelExporter from "../../../clases/ExcelMaker/CompraExcel.js";
export default {
  name: "ComprasCRUD",
  components: {
    modal,
    uvDataTable,
    ComprasForm,
    ComprasXml,
  },
  props: [],
  data() {
    return {
      excelData: [],
      excelDataItems: [],
      excelModal: false,
      docsEmpty: true,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      origenes: [],
      self: this,
      showModal: false,
      docRecepTypeModal: false,
      docRecepIsManual: false,
      formKey: 0,
      Documentos: [],
      selectedFile: null,
      showDocuments: false,
      listDocuments: [],
      acceptedDocuments: [],
      multipleDocuments: false,
      formIndex: 0,
      editMode: false,
      showCreator: false,
      editData: [],
      usuarios: [],
      presentaciones: [],
      Proveedores: [],
      presentacionesAll: [],
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: false,
        rawText: "Compras",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Nueva Compra",
            icon: "lni lni-clipboard",
            buttonId: "addDocumentRecepcion",
          },
          {
            text: "Editar Compra",
            icon: "lni lni-pencil-alt",
            buttonId: "editDocumentRecepcion",
            require: true,
          },
          {
            text: "Cancelar compra",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentRecepcion",
            require: true,
          },
          {
            text: "Exportar compras a excel",
            icon: "lni lni-download",
            buttonId: "exportExcel",
          },
          {
            text: "Subir Documentos",
            icon: "lni lni-upload",
            buttonId: "uploadDocument",
            require: true,
          },
          // {
          //   text: "Exportar items a excel",
          //   icon: "lni lni-download-1",
          //   buttonId: "exportExcelItems",
          // },
        ],
        fields: [
          {
            text: "Documento de compras",
            value: "Nombre",
          },
          {
            text: "Descripción",
            value: "dsc",
          },
          {
            text: "Fecha Creación",
            value: "Fecha",
          },
          {
            text: "Proveedores",
            value: "proveedoresArray",
          },
          {
            text: "Almacen",
            value: "origenNombre",
            canBeFiltered: true,
          },
          {
            text: "Total",
            value: "Total",
          },
          {
            text: "Estatus",
            value: "Status",
            format: (row) => {
              if (row["sts"] == "A") {
                return '<b style="color:green;">Aplicado </b>';
              } else if (row["sts"] == "C") {
                return '<b style="color:red;">Cancelado </b>';
              } else {
                return '<b style="color:orange;">Pendiente</b>';
              }
            },
            canBeFiltered: true,
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "indigo",
                icon: "mdi-file-outline",
                tooltip: "Ver Documentos",
                buttonId: "Verdocumentos",
                value: "id",
                showBy: "availableToDoc",
              },
              {
                color: "green",
                text: "Aplicar",
                buttonId: "Aplicarinvantario",
                value: "id",
                showBy: "availableToApplay",
              },
              {
                color: "red",
                text: "PDF",
                buttonId: "acusePDF",
                value: "id",
                showBy: "availableToPDF",
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addDocumentRecepcion") {
        this.formIndex++;
        this.editMode = false;
        this.docRecepTypeModal = true;
      }
      if (buttonId == "editDocumentRecepcion") {
        this.formIndex++;
        this.editMode = true;
        this.docRecepIsManual = true;
        this.editData = this.$pgsHelper.getById(
          this.Documentos,
          "id",
          idSelected[0]
        );
        this.showModal = true;
      }

      if (buttonId == "deleteDocumentRecepcion") {
        this.deleteDoc(idSelected[0]);
      }
      if (buttonId == "Aplicarinvantario") {
        this.aplicarCompra(idSelected);
      }
      if (buttonId == "exportExcel") {
        if (this.Documentos.length > 0) {
          this.docsEmpty = false;
        } else {
          this.docsEmpty = true;
        }
        this.excelModal = true;
      }
      // if (buttonId == "exportExcelItems") {
      //   this.processExcelItems();
      // }
      if (buttonId == "acusePDF") {
        let data = this.$pgsHelper.getById(this.Documentos, "id", idSelected);
        if (data) {
          // Obtener el array de adquisiciones (adq) del objeto data
          let adquisiciones = data.adq ? data.adq : [];

          // Preparar agrupación por proveedor
          const agrupadosPorProveedor = adquisiciones.reduce(
            (acc, producto) => {
              // Obtener la presentación específica del producto usando prs
              let presentacionProducto = this.$pgsHelper.getById(
                this.presentaciones,
                "Id",
                producto.prs
              );

              // Asignar a "Proveedor desconocido" si no se encuentra una presentación específica
              if (!presentacionProducto) {
                const proveedorDesconocido = "Proveedor desconocido";
                if (!acc[proveedorDesconocido]) {
                  acc[proveedorDesconocido] = {
                    proveedor: proveedorDesconocido,
                    items: [],
                  };
                }
                producto.proveedor = proveedorDesconocido;
                acc[proveedorDesconocido].items.push(producto);
              } else {
                // Obtener el proveedor asociado con la presentación
                let proveedor = this.Proveedores.find(
                  (prv) => prv.id === presentacionProducto.pvd
                ) || { Nombre: "Proveedor desconocido" };

                producto.proveedor = proveedor.Nombre;

                // Agrupar por proveedor
                if (!acc[producto.proveedor]) {
                  acc[producto.proveedor] = {
                    proveedor: producto.proveedor,
                    items: [],
                  };
                }

                // Clonar el producto con la presentación específica
                let productoClonado = {
                  ...producto,
                  presentacion: presentacionProducto,
                };
                acc[producto.proveedor].items.push(productoClonado);
              }

              return acc;
            },
            {}
          );
          // Convertir agrupación en array de grupos
          let grupos = Object.values(agrupadosPorProveedor);
          const extras = {
            Fecha: data.Fecha,
            dpt: data.dpt,
            origenNombre: data.origenNombre,
            dsc: data.dsc,
            Total: data.Total,
            nts: data.nts,
          };
          this.generatePdf(grupos, extras);
        }
      }
      if (buttonId == "uploadDocument") {
        this.acceptedDocuments = [".pdf", ".xml"];
        this.multipleDocuments = true;
        this.$nextTick(() => {
          const inputEl =
            this.$refs.hiddenFileInput.$el.querySelector('input[type="file"]');

          if (inputEl) {
            inputEl.click();
          }

          this.editData = this.$pgsHelper.getById(
            this.Documentos,
            "id",
            idSelected[0]
          );
        });
      }
      if (buttonId == "Verdocumentos") {
        this.editData = this.$pgsHelper.getById(
          this.Documentos,
          "id",
          idSelected
        );
        this.getAllDocument(this.editData);
        this.showDocuments = true;
      }
    },
    async processExcelInfo() {
      let dataExcel = [];
      this.Documentos.forEach((doc) => {
        if (doc.adq && doc.adq.length > 0) {
          const grupos = doc.adq.reduce((acc, item) => {
            const precioTotal = item.pcu.C * item.cnt;
            const unidadPrecio = item.pcu.M;
            const proveedorNombre = item.proveedor;

            if (!acc[proveedorNombre]) {
              acc[proveedorNombre] = {
                proveedor: proveedorNombre,
                items: [],
                total: {},
              };
            }

            acc[proveedorNombre].items.push(item);

            if (!acc[proveedorNombre].total[unidadPrecio]) {
              acc[proveedorNombre].total[unidadPrecio] = 0;
            }
            acc[proveedorNombre].total[unidadPrecio] += precioTotal;

            return acc;
          }, {});

          let data = Object.values(grupos).map((grupo) => ({
            ...grupo,
            total: Object.entries(grupo.total)
              .map(([moneda, total]) => `$${total}`)
              .join(", "),
          }));

          data.forEach((prov) => {
            dataExcel.push({
              Documento: doc.Nombre,
              Fecha: doc.Fecha,
              Descripcion: doc.dsc,
              Almacen: doc.origenNombre,
              Proveedor: prov.proveedor,
              Total: prov.total,
            });
          });
        }
      });

      // Uso del módulo exportador:
      const buffer = await ComprasExcelExporter.exportPorProveedor(
        dataExcel,
        `COMPRAS ${this.input_date} - ${this.input_date_final}`
      );

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `COMPRAS PROVEEDOR ${this.input_date}-${this.input_date_final}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      this.excelModal = false;
    },
    async processExcelItems() {
      const dataExcel = [];

      this.Documentos.forEach((doc) => {
        if (doc.adq && doc.adq.length > 0) {
          doc.adq.forEach((item) => {
            const presentacionTotal = this.$pgsHelper.getById(
              this.presentaciones,
              "Id",
              item.prs
            );
            const presentacion = presentacionTotal.nom;

            dataExcel.push({
              Documento: doc.Nombre,
              Fecha: doc.Fecha,
              Descripcion: doc.dsc,
              Almacen: doc.origenNombre,
              Proveedor: item.proveedor,
              Producto: item.producto?.nombre || "No encontrado",
              Presentacion: presentacion,
              "Precio Unitario": item.pcu.M,
              Cantidad: item.cnt,
              "Precio Total": item.pcu.C * item.cnt,
            });
          });
        }
      });

      // Uso del módulo exportador:
      const buffer = await ComprasExcelExporter.exportPorItems(
        dataExcel,
        `COMPRAS ${this.input_date} - ${this.input_date_final}`
      );

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `COMPRAS ITEMS ${this.input_date}-${this.input_date_final}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      this.excelModal = false;
    },
    // async processDocument
    onFileSelected() {
      const allowedTypes = ["application/pdf", "text/xml", "application/xml"];
      const validateDocs = this.selectedFile.filter((file) =>
        allowedTypes.includes(file.type)
      );

      if (validateDocs.length !== this.selectedFile.length) {
        this.$swal({
          title: "Documentos no válidos",
          text: "Algunos documentos no son PDF o XML válidos",
          icon: "error",
          showCancelButton: false,
        });
        return;
      }

      const single = "el siguiente documento: ";
      const multiple = "los siguientes documentos: ";
      const listaDocs = validateDocs.map((file) => `${file.name}`).join(" - ");

      this.$swal({
        title: "¿Deseas guardar cambios?",
        text: `Se guardará ${
          validateDocs.length > 1 ? multiple : single
        } ${listaDocs} en ${this.editData.origenNombre} a la ${
          this.editData.Nombre
        }`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, guardar",
        cancelButtonText: "Cancelar",
        preConfirm: async () => {
          const formData = new FormData();
          validateDocs.forEach((file) => {
            formData.append("Documentos[]", file);
          });
          formData.append("Tenant", this.$store.getters.getFirebaseApp.tenant);
          formData.append("CompraId", this.editData.id);

          return await this.$store.getters.getFirebaseApp.fba
            .callForm("AMC-Compras-uploadDocumentos", formData, {
              "Content-Type": "multipart/form-data",
            })
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              allowOutsideClick: false,
              title: "Guardado",
              text: "Los documentos se guardon correctamente",
              icon: "success",
            });
            this.getDocuments();
          } else {
            this.$swal(
              "Error al guardar los documentos",
              result.value.data.error,
              "error"
            );
          }
        }
        this.selectedFile = null;
      });
    },
    // async processExcelInfo() {
    //   let dataExcel = [];
    //   this.Documentos.forEach((doc) => {
    //     if (doc.adq) {
    //       if (doc.adq.length > 0) {
    //         const grupos = doc.adq.reduce((acc, item, index) => {
    //           const precioTotal = item.pcu.C * item.cnt;
    //           const unidadPrecio = item.pcu.M;
    //           const proveedorNombre = item.proveedor;
    //           item.globalIndex = index;
    //           if (!acc[proveedorNombre]) {
    //             acc[proveedorNombre] = {
    //               proveedor: proveedorNombre,
    //               items: [],
    //               total: {},
    //             };
    //           }

    //           acc[proveedorNombre].items.push(item);

    //           if (!acc[proveedorNombre].total[unidadPrecio]) {
    //             acc[proveedorNombre].total[unidadPrecio] = 0;
    //           }
    //           acc[proveedorNombre].total[unidadPrecio] += precioTotal;

    //           return acc;
    //         }, {});

    //         let data = Object.values(grupos).map((grupo) => ({
    //           ...grupo,
    //           total: Object.entries(grupo.total)
    //             .map(([moneda, total]) => ` $${total}`)
    //             .join(", "),
    //         }));
    //         data.forEach((prov) => {
    //           dataExcel.push({
    //             Documento: doc.Nombre,
    //             Fecha: doc.Fecha,
    //             Descripcion: doc.dsc,
    //             Almacen: doc.origenNombre,
    //             Proveedor: prov.proveedor,
    //             Total: prov.total,
    //           });
    //         });
    //       }
    //     }
    //   });
    //   this.excelData = dataExcel;

    //   let data = await this.$refs.btnExcel.getProcessedJson(dataExcel);
    //   this.$refs.btnExcel.export(
    //     this.$refs.btnExcel.jsonToXLS(data),
    //     "COMPRAS " + this.input_date + " - " + this.input_date_final,
    //     "application/vnd.ms-excel"
    //   );
    //   this.excelModal = false;
    // },
    // async processExcelItems() {
    //   const dataExcel = [];

    //   this.Documentos.forEach((doc) => {
    //     if (doc.adq && doc.adq.length > 0) {
    //       doc.adq.forEach((item) => {
    //         const presentacionTotal = this.$pgsHelper.getById(
    //           this.presentaciones,
    //           "Id",
    //           item.prs
    //         );
    //         const presentacion = presentacionTotal.nom;

    //         const precioTotal = item.pcu.C * item.cnt;
    //         const unidadPrecio = item.pcu.M;
    //         const nombreProducto = item.producto?.nombre
    //           ? item.producto.nombre
    //           : "No encontrado";

    //         dataExcel.push({
    //           Documento: doc.Nombre,
    //           Fecha: doc.Fecha,
    //           Descripcion: doc.dsc,
    //           Almacen: doc.origenNombre,
    //           Proveedor: item.proveedor,
    //           Producto: nombreProducto,
    //           Presentacion: presentacion,
    //           "Precio Unitario": unidadPrecio,
    //           Cantidad: item.cnt,
    //           "Precio Total": precioTotal,
    //         });
    //       });
    //     }
    //   });

    //   this.excelDataItems = dataExcel;

    //   try {
    //     const dataProcesada = await this.$refs.btnExcel.getProcessedJson(
    //       dataExcel
    //     );
    //     this.$refs.btnExcelItems.export(
    //       this.$refs.btnExcelItems.jsonToXLS(dataProcesada),
    //       `COMPRAS ${this.input_date} - ${this.input_date_final}`,
    //       "application/vnd.ms-excel"
    //     );
    //     this.excelModal = false;
    //   } catch (error) {
    //     console.error("Error al exportar a Excel:", error);
    //   }
    // },
    async generatePdf(data, extras) {
      let mainData = {
        FI: extras.Fecha || "Fecha no disponible", // Fecha inicial de la orden
        FG: new moment().format("DD/MM/YYYY"), // Fecha de generación del PDF
        HG: new moment().format("HH:mm:ss"), // Hora de generación del PDF
        TITLE: "COMPRA",
        data: data, // Pasamos los grupos por proveedor
        dpt: extras.dpt,
        origen: extras.origenNombre,
        dsc: extras.dsc,
        total: extras.Total,
        nts: extras.nts,
      };

      // Generar el documento con los datos organizados
      let docData = AcuseCompras.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    async aplicarCompra(id) {
      let data = this.$pgsHelper.getById(this.Documentos, "id", id);

      if (data.sts != "A" && data.sts != "C") {
        let datos = { Id: id };
        this.$alert.alertConfirm({
          action: "enviar a inventario",
          obj: "la compra",
          route: "AMC-Compras-applyCompra",
          data: datos,
          onSuccess: async () => {
            //this.getPresentacionesByProduct()
            await this.getDocuments();
          },
        });
      }
    },
    async getPresentaciones() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("AMC_Presentaciones", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      if (data.empty) {
        this.presentaciones = [];
        this.presentacionesAll = [];
      } else {
        let doc = data.docs.map((doc) => {
          return { Id: doc.ref.id, ...doc.data() };
        });
        let presentaciones = [];
        let presentacionesAll = [];
        doc.forEach((data) => {
          if (!data.Dlat) {
            presentaciones.push(data);
          }
          presentacionesAll.push(data);
        });
        this.presentaciones = presentaciones;
        this.presentacionesAll = presentacionesAll;
      }
    },
    async createDocument() {
      this.$swal({
        title: "¿Deseas crear un nuevo documento de recepción de mercancias?",
        text: "Al crear el documento podras agregar los productos necesarios para ingresar a inventario",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Crear Documento",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = {};
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-deleteCategoria", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento Creado",
              "El documento se creo correctamente",
              "success"
            );
            this.$router.push({
              path:
                "/productos-inventarios/documentoRecepcion/" +
                result.value.data.data.id,
            });
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    getDocuById(code) {
      let itemIndex = this.$_.findIndex(this.Documentos, { id: code });
      if (itemIndex >= 0) {
        return this.Documentos[itemIndex];
      }

      return false;
    },
    async getAllDocument(data) {
      const response =
        await this.$store.getters.getFirebaseApp.fbstore.listAllFiles(
          `AMC_ComprasDocumentos/${data.id}`
        );
      this.listDocuments = response || [];
    },
    getDocumentType(document) {
      const fileName = document.name.toLowerCase();

      if (fileName.endsWith(".pdf")) {
        return {
          icon: "mdi-file-pdf-box",
          color: "red",
          textColor: "red--text",
        };
      } else if (fileName.endsWith(".xml")) {
        return { icon: "mdi-xml", color: "indigo", textColor: "indigo--text" };
      } else {
        return { icon: "mdi-file", color: "grey" };
      }
    },
    async viewDocument(document) {
      const response =
        await this.$store.getters.getFirebaseApp.fbstore.viewDocument(document);
      window.open(response, "_blank");
    },
    async deleteDocument(document) {
      const formData = new FormData();
      formData.append("Tenant", this.$store.getters.getFirebaseApp.tenant);
      formData.append("CompraId", this.editData.id);
      formData.append("Documentos[]", document);
      this.$swal({
        title: "¿Deseas eliminar el documento?",
        text: `Se eliminará el documento ${document}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .callForm("AMC-Compras-eraseDocumentos", formData, {
              "Content-Type": "multipart/form-data",
            })
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento se elimino correctamente",
              "El documento se elimino correctamente",
              "success"
            );
            this.getDocuments();
            this.showDocuments = false;
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    async successData() {
      await this.getDocuments();
      await this.getPresentaciones();
      this.showModal = false;
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async deleteDoc(id) {
      let docu = this.getDocuById(id);
      let datos = {
        Id: id,
      };

      this.$swal({
        title: "¿Deseas cancelar la compra?",
        text: "Al eliminarlo se revertira toda la informacion generada",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cancelado",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AMC-Compras-cancelCompra", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Documento se elimino correctamente",
              "El documento se elimino correctamente",
              "success"
            );
            this.getDocuments();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    async getProveedores() {
      let proveedorArray = [];
      const database = await this.$store.getters.getFirebaseApp.database;
      const data = await database.queryBuilder("AMC/Provedores", []);
      if (data.exists()) {
        let arrayFactura = Object.entries(data.val());
        arrayFactura.forEach((element) => {
          proveedorArray.push({
            id: element[0],
            Nombre: element[1]["nom"],
          });
        });
        this.Proveedores = proveedorArray;
      }
    },
    async getDocuments() {
      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      var data = await firestore.queryBuilder("AMC_Compras", [
        firestore.where("mmt", ">=", startDate),
        firestore.where("mmt", "<", end + "~"),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      document.forEach((data) => {
        if (data.sts !== "OC") {
          /* let dateFormat = new firestore.Timestamp(
          data.FechaCreacion.seconds,
          data.FechaCreacion.nanoseconds
        );*/
          let fecha = new moment(data.mmt, "YYYY-MM-DD_HH:mm:ss");
          let origenData = this.getOrigenById(data.amc);
          let total = 0;
          data.proveedoresArray = [];
          try {
            data.adq.forEach((ins) => {
              total += Number(ins.pcu.C) * ins.cnt;
              const producto = this.$pgsHelper.getById(
                this.global_prod,
                "id",
                ins.prd
              );
              const presentacionTotal = this.$pgsHelper.getById(
                this.presentaciones,
                "Id",
                ins.prs
              );

              const presentacion = presentacionTotal.pvd;
              ins.rdm = presentacionTotal.rdm;

              const proveedor =
                presentacion &&
                this.Proveedores.find((p) => p.id === presentacion)?.Nombre;

              if (proveedor) {
                ins.proveedor = proveedor;
                if (!data.proveedoresArray.includes(proveedor)) {
                  data.proveedoresArray.push(proveedor);
                }
              }
              if (producto) {
                ins.producto = {
                  nombre: producto.Nombre,
                  unidadMedida: producto.Extra?.AYB?.UM || "PZA",
                };
              }
            });
            data.proveedoresArray = data.proveedoresArray.join(", ");
          } catch (e) {
            console.log(e);
          }

          this.Documentos.push({
            id: data.id,
            origenId: origenData.id,
            origenNombre: origenData.Nombre,
            Nombre: "Compra - " + data.id,
            Fecha: fecha.format("YYYY-MM-DD HH:mm"),
            //Departamento: data.Departamentos[0],
            Aplicado: data.sts,
            availableToApplay: data.sts == "P" ? true : false,
            availableToPDF: data.sts != "C" ? true : false,
            availableToDoc: data.sts != "C" && data.doc == true ? true : false,
            Status: data.sts == "F" ? "Completado" : "Pendiente",
            Total: this.$pgsHelper.formatNumber(total),
            ...data,
          });
        }
      });

      this.Documentos = this.$_.orderBy(this.Documentos, "Fecha", "desc");
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    getOrigenById(code) {
      let itemIndex = this.$_.findIndex(this.origenes, { id: code });
      if (itemIndex >= 0) {
        return this.origenes[itemIndex];
      }

      return false;
    },
  },
  computed: {
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let productos = [];
      prod.forEach((element) => {
        if (element.Tipo == "AYB-Insumo" && !element.Dlat) {
          productos.push(element);
        }
      });

      let data = productos;
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");
      return sortReservations;
    },
  },
  watch: {},
  mounted() {},
  async created() {
    await this.getProveedores();
    await this.getPresentaciones();
    await this.getOrigenes();
    //await this.getDocuments();
  },
};
</script>
